module.exports = __webpack_public_path__ + "static/assets/5577591f715b145cda8ef9152869ff2a.png";